module.exports = __webpack_public_path__ + "static/media/icon_media.cab782b8.svg";